import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { urlBackend } from '@/shared/constants';
import {AlertSeverityEnum, Deprecacion , DeprecacionPagingRes, UseMutationsParams} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';


const { get, post, put } = erpApi();

///* tanSctack query
export const usefetchDeprecaciones = (params?: GetDeprecacionParams) => {
    return useQuery({
      queryKey: ['Depreciacion', ...Object.values(params || {})],
      queryFn: async () => {
        return getDeprecaciones(params);
      },
    });
  };
  
  export const useGetDeprecacion = (id: string) => {
    return useQuery({
      queryKey: ['Depreciacion', id],
      queryFn: async () => {
        return getDeprecacion(id);
      },
    });
  };
  
  export const useCreateDeprecacion = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: createDeprecacion,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['Depreciacion'] });
  
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Depreciacion creada correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  
  export const useUpdateDeprecacion = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: updateDepreciacion,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['Depreciacion'] });
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Depreciacion actualizada correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  
  ///* axios
  export type GetDeprecacionParams = {
    page?: number;
    page_size?: number;
    activo?:string
  };
  
  export type CreateDeprecacionParams = Omit<Deprecacion, 'id_deprecacion'>;
  export type UpdateDeprecacionParams = {
    id: string;
    data: Omit<Deprecacion, 'id_deprecacion'>;
  };
  
  export const getDeprecaciones = async (params?: GetDeprecacionParams) => {
    const queryParams = getUrlParamsFetch({ ...params });
  
    return get<DeprecacionPagingRes>(
      `${urlBackend}api/v1/deprecacion/?${queryParams}`,
      true
    );
  };
  
  export const getDeprecacion = async (id: string) => {
    try{
    return await get<Deprecacion>(`${urlBackend}api/v1/deprecacion/${id}/`, true);
    }
    catch(error){
      return handleAxiosError(error);
    }
    };
  
  export const createDeprecacion = async (data: CreateDeprecacionParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    setIsGlobalLoading(true);
  
    return post<Deprecacion>(`${urlBackend}api/v1/deprecacion/`, data, true);
  };
  
  export const updateDepreciacion = async ({ id, data }: UpdateDeprecacionParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    setIsGlobalLoading(true);
  
    return put<Deprecacion>(`${urlBackend}api/v1/deprecacion/${id}/`, data, true);
  };
  